import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GridDataResult, PageChangeEvent, RemoveEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { translate, TranslocoService } from '@jsverse/transloco';
import { IBasketItem, IBasketItemSearchRequest, IUpdateBasketItemRequest } from 'src/app/basket/models/basket';
import { BasketService } from 'src/app/basket/services/basket.service';
import { ICompany } from 'src/app/company/models/company';
import {
  IBase,
  IBaseSearchRequest,
  IGridResult,
  IGridState,
  PageSize,
} from 'src/app/core/models/base';
import { AppNotificationService } from '../services/notification.service';
import { BehaviorSubject, Observable } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'app-basket-grid',
    templateUrl: './basket-grid.component.html',
    styleUrls: ['./basket-grid.component.scss'],
    standalone: false
})
export class BasketGridComponent implements OnInit {
  constructor(
    private basketService: BasketService,
    private appnotificationService: AppNotificationService
  ) {}

  @Input() data: GridDataResult;
  @Input() loading: any;
  @Input() request: IBasketItemSearchRequest;
  @Input() skip: number;
  @Input() pageSize: number;
  @Input() isAdminView: boolean = false;
  @Input() currentCompany: ICompany = null;

  @Output() onReload = new EventEmitter<IBaseSearchRequest>();

  ngOnInit(): void {}

  public rowClass = (context: RowClassArgs) => {
    return { 'inactive-product': !context.dataItem.product?.isActive };
  };

  gridState: IGridState = {
    pageSize: 25,
    skip: 0,
  };

  get pageSizes() {
    return PageSize;
  }

  public removeHandler(args: RemoveEvent): void {
    // remove the current dataItem from the current data source,
    // `editService` in this example
    if (this.isAdminView) {
      this.basketService
      .deleteBasketItem(args.dataItem.id)
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        this.onReload.emit(this.request);
        this.successDeleteNotification();
      });
    } else {
      this.basketService
      .deleteBasketItem(args.dataItem.id)
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        this.onReload.emit(this.request);
        this.successDeleteNotification();
      });
    }
  }

  successDeleteNotification(){
    this.appnotificationService.notification$.next({
      message:translate('basket.deleteSuccess'),
      style: 'success',
    });
  }

  updateQuantity(newQuantity: number, basket: IBasketItem): void {
    if (this.isAdminView) {
      const request: IUpdateBasketItemRequest = {
        quantity: newQuantity,
        id: basket.id
      };

      this.basketService
        .updateBasketItem(request)
        .pipe(untilDestroyed(this))
        .subscribe((response) => {
          this.onReload.emit(this.request);
          this.successSaveNotification();
        });
    } else {
      const request: IUpdateBasketItemRequest = {
        quantity: newQuantity,
        id: basket.id,
      };

      this.basketService
        .updateBasketItem(request)
        .pipe(untilDestroyed(this))
        .subscribe((response) => {
          this.onReload.emit(this.request);
          this.successSaveNotification();
        });
    }


  }

  successSaveNotification(){
    this.appnotificationService.notification$.next({
      message:translate('basket.updateSuccess'),
      style: 'success',
    });
  }

  // Paging Start

  onPageSizeChange(pageSize: number) {
    this.onPageChange({ skip: this.gridState.skip, take: pageSize });
  }

  onGridReload() {
    this.onReload.emit(this.request);
  }

  onPageChange({ skip, take }: PageChangeEvent) {
    const page = Math.round((skip + take) / take);

    this.gridState.skip = skip;
    this.gridState.pageSize = take;

    this.request.pageNumber = page;
    this.request.pageSize = take;

    this.onReload.emit(this.request);
  }

  // Paging End
}
